import { Component, h, Prop } from '@stencil/core';

export type SwpChatbotBannerClassName = "primary" | "secondary" | "tertiary";

@Component({
  tag: 'swp-chatbot-banner',
  styleUrl: 'swp-chatbot-banner.scss',
  shadow: false,
})
export class SwpChatbotBanner {
  /**
   * For styling the banner in either "primary" | "secondary" | "tertiary"
   */
  @Prop() bannerClassName: SwpChatbotBannerClassName = "secondary";

  render() {
    return <div class={"swp-chatbot-banner " + this.bannerClassName}>
      <slot></slot>
    </div>
  }
}
